import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getChannels = async (id) => {
  loaderService.show();
  const response = await apiService.get(
    `/segmentacion/canales/?unidad_negocio=${id}`,
  );
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const postChannel = async (body) => {
  loaderService.show();
  const response = await apiService.post('/segmentacion/canales/', body);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const putChannel = async (body) => {
  loaderService.show();
  const response = await apiService.put('/segmentacion/canales/', body);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const deleteChannel = async (id) => {
  loaderService.show();
  const response = await apiService.delete(`/segmentacion/canales/?id=${id}`);
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

export {
  getChannels, postChannel, putChannel, deleteChannel,
};
